import { THAI_REGEX } from '@constants/regex';

type HTMLElement = HTMLTextAreaElement | HTMLInputElement;

export function replaceAllowCharacter<T extends HTMLElement>(e: React.ChangeEvent<T>, allowOnly: 'en' | 'th') {
  e.target.value = replaceAllowCharacterValue(e.target.value, allowOnly);
  return e;
}

export function replaceAllowCharacterValue(value: string, allowOnly?: 'en' | 'th') {
  if (allowOnly === 'en' && value && value.match(THAI_REGEX)) {
    value = value.replace(THAI_REGEX, '');
  }
  return value;
}
